import React from 'react';

import { NewProductDetails } from 'application-types';

import { RateModifierCheckbox } from 'pages/portal/admin/channel/products-services/products/RateModifierCheckbox';
import {
  ModifierType,
  RateModifierInput,
} from 'pages/portal/admin/channel/products-services/products/RateModifierInput';

import styles from './CreateProductForm.scss';
import cx from 'classnames';

interface AdminFeeTaxSectionProps {
  productDetails: NewProductDetails;
  onUpdate: (value: any, field: string) => void;
  selected: boolean;
  onRateToggle: (type: ModifierType) => void;
}

export function AdminFeeTaxSection({
  productDetails,
  onUpdate,
  selected,
  onRateToggle,
}: AdminFeeTaxSectionProps) {
  return (
    <div className={cx(styles.additionalOptionGroup, 'mb-2')}>
      <RateModifierCheckbox
        selected={selected}
        toggleRateModifier={onRateToggle}
        type={ModifierType.ADMIN_FEE_TAX}
      />
      {selected && (
        <div className={styles.additionalOptionGroup}>
          <RateModifierInput
            modifierType={productDetails.adminFeeTax?.type}
            modifierValue={productDetails.adminFeeTax?.value}
            updateDetails={onUpdate}
            type={ModifierType.ADMIN_FEE_TAX}
          />
        </div>
      )}
    </div>
  );
}
